import { Controller } from "@hotwired/stimulus"
import {Loggable} from "./concerns/loggable"

export default class extends Controller {

  static targets = [ "entry" ]

  initialize(){
    Loggable(this, {debug: true})
    this.frameLoaded = this.frameLoaded.bind(this)
  }
  connect(){
    this.hideCounterparts()
    this.element.addEventListener("turbo:frame-load", this.frameLoaded)
  }

  disconnect(){
    this.element.removeEventListener("turbo:frame-load", this.frameLoaded)
  }

  frameLoaded(event){
    const entry = this.entryTargets.find(entry => entry.contains(event.target))
    if (entry && entry.getElementsByClassName("entry--player").length > 1) {
      this.removeNoise(entry)
    }
  }

  hideCounterparts(){
    this.entryTargets.forEach((e) => {
      if ( e.dataset.counterpartId && e.dataset.postType=="InPersonLive" ) {
        if(this.counterpartFor(e)){
          this.movePlayer(this.counterpartFor(e),e)
          this.removeNoise(e)
          this.hideCounterpart(e)
        } else {
          this.log("counterpart not found")
        }
      }
    })
  }

  hideCounterpart(entry){
    this.counterpartFor(entry).remove()
  }

  movePlayer(source_entry,target_entry){
    let sourcePlayer = source_entry.getElementsByClassName("entry--player")[0]
    if (sourcePlayer.innerHTML.trim() === "") {
      sourcePlayer.remove()
    } else {
      let targetPlayer = target_entry.getElementsByClassName("entry--player")[0]
      $(sourcePlayer).insertAfter(targetPlayer)
    }
  }

  // para evitar ruido no muestro botón bloqueado si ya hay otro botón.
  // si hay 2 botones bloqueados dejo el de reserva.
  removeNoise(entry) {
    const buttons = Array.from(entry.getElementsByClassName("btn")).filter(button => !button.classList.contains("placeholder"));
    const levelUpBadges = Array.from(entry.getElementsByClassName("level-up-badge"));

    if (buttons.length > 1) {
      buttons.filter((b) => { return b.parentNode.dataset.hybridInfo === 'blocked-enter-live' }).forEach((b) => {
        b.remove();
      });
    }
    if (levelUpBadges.length > 1) {
      levelUpBadges[0].remove();
    }
  }

  counterpartFor(entry){
    return this.entryTargets.filter((e)=>{ return e.dataset.postId==entry.dataset.counterpartId })[0]
  }

}
